module.exports = __webpack_public_path__ + "static/media/Popmama.com Purple (Original)_Transparent Background.df5e0614.png";